import { MessageBar, MessageType } from "./index";
import { SnackbarContent } from "notistack";
import React, { forwardRef } from "react";

interface Props {
  message: {
    text: string;
    variant: MessageType;
    className?: string;
    action?: React.FunctionComponent;
    animation?: React.FunctionComponent;
  };
}
const SnackMessage = forwardRef<HTMLDivElement, Props>(({ message }, ref) => {
  const { text, variant, className, action, animation } = message;

  return (
    <SnackbarContent ref={ref}>
      <MessageBar
        text={text}
        type={variant}
        className={className}
        isSnackbar={true}
        Action={action}
        Animation={animation}
      />
    </SnackbarContent>
  );
});

SnackMessage.displayName = "SnackMessage";
export { SnackMessage };
